import { render } from "./ShieldsPage.vue?vue&type=template&id=b46cf586&lang=true"
import script from "./ShieldsPage.vue?vue&type=script&lang=js"
export * from "./ShieldsPage.vue?vue&type=script&lang=js"

import "./ShieldsPage.vue?vue&type=style&index=0&id=b46cf586&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__